import { ALL_ALLOWED_LOCALES } from 'constants/locale';
import { gql } from 'data/graphql/utils/gql';

const MAX_QUERIED_REVIEWS = 300;

const reviewFragment = gql`
  fragment reviewFields on ReviewCollection {
    items {
      __typename
      sys {
        id
      }
      descriptionShort
      description
      customerName
      slugs
      overallRating
      treatmentName
      facilities
      friendliness
      objectId
      date
      customerAge
      professionalism
      customerCountryName
      customerCountryCode
      verifiedReview
      source
      reviewId
      destination: destinationCollection(limit: 10) {
        items {
          __typename
          ... on Clinic {
            __typename
            slug
            name
          }
          ... on DoctorProfile {
            __typename
            slug
            firstName
            lastName
          }
          ... on TreatmentPage {
            __typename
            slug
            title
          }
        }
      }
    }
  }
`;

const reducedReviewFragment = gql`
  fragment reviewFields on ReviewCollection {
    items {
      __typename
      sys {
        id
      }
      slugs
      overallRating
      facilities
      friendliness
      professionalism
      verifiedReview
    }
  }
`;

export const GET_REVIEWS = gql`
  query getReviews($locale: String!) {
    reviews: reviewCollection(locale: $locale, limit: ${MAX_QUERIED_REVIEWS}) {
      ...reviewFields
    }
  }

  ${reviewFragment}
`;

export const GET_CLINIC_REVIEWS = gql`
  query getReviews($locale: String!, $slug: String!) {
    reviews: clinicCollection(
      locale: $locale
      limit: 1
      where: { slug: $slug }
    ) {
      items {
        sys {
          id
        }
        slug
        linkedFrom(${ALL_ALLOWED_LOCALES}) {
          reviewCollection(limit: ${MAX_QUERIED_REVIEWS}) {
            ...reviewFields
          }
        }
      }
    }
  }

  ${reviewFragment}
`;

export const GET_DOCTOR_REVIEWS = gql`
  query getReviews($locale: String!, $slug: String!) {
    reviews: doctorProfileCollection(
      locale: $locale
      limit: 1
      where: { slug: $slug }
    ) {
      items {
        sys {
          id
        }
        slug
        linkedFrom(${ALL_ALLOWED_LOCALES}) {
          reviewCollection(limit: ${MAX_QUERIED_REVIEWS}) {
            ...reviewFields
          }
        }
      }
    }
  }

  ${reviewFragment}
`;

export const GET_TREATMENT_REVIEWS = gql`
  query getReviews($locale: String!, $slug: String!) {
    reviews: treatmentPageCollection(
      locale: $locale
      limit: 1
      where: { slug: $slug }
    ) {
      items {
        sys {
          id
        }
        slug
        linkedFrom(${ALL_ALLOWED_LOCALES}) {
          reviewCollection(limit: ${MAX_QUERIED_REVIEWS}) {
            ...reviewFields
          }
        }
      }
    }
  }

  ${reviewFragment}
`;

export const GET_MULTIPLE_CLINICS_REVIEWS = gql`
query getReviews($locale: String!, $slugs: [String]!) {
  reviews: clinicCollection(
    locale: $locale
    limit: 10
    where: { slug_in: $slugs }
  ) {
    items {
      sys {
        id
      }
      slug
      linkedFrom(${ALL_ALLOWED_LOCALES}) {
        reviewCollection(limit: ${MAX_QUERIED_REVIEWS}) {
          ...reviewFields
        }
      }
    }
  }
}

${reducedReviewFragment}
`;

export const GET_ALL_REVIEWS_COUNT = gql`
  query getReviews($skip: Int) {
    reviews: reviewCollection(limit: 1000, skip: $skip) {
      total
      ...reviewFields
    }
  }

  ${reducedReviewFragment}
`;
